"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationTokenHook = void 0;
var CancellationTokenHook = /** @class */ (function () {
    function CancellationTokenHook(params) {
        this.token = params.token;
    }
    CancellationTokenHook.prototype.onRequest = function (req) {
        if (this.token) {
            if (this.token.isCanceled()) {
                throw this.token.reason;
            }
            this.token.toPromise().then(function (reason) {
                if (reason) {
                    req.destroy(reason);
                }
            });
        }
    };
    CancellationTokenHook.prototype.onResponse = function () {
        if (this.token && !this.token.isCanceled()) {
            this.token.destroy();
        }
    };
    CancellationTokenHook.prototype.onError = function () {
        if (this.token && !this.token.isCanceled()) {
            this.token.destroy();
        }
    };
    return CancellationTokenHook;
}());
exports.CancellationTokenHook = CancellationTokenHook;
//# sourceMappingURL=CancellationTokenHook.js.map